/**
 * artistsStore.ts
 *
 * Single source of truth for the artists/makers data.
 * Both the homepage "Meet Our Makers" section and the Artists page
 * read from and write to this shared store.
 *
 * Storage key: "ma_artists_shared"
 */

import { defaultArtists, type ArtistEntry } from "@/data/siteContent";

export type { ArtistEntry };

export const SHARED_ARTISTS_KEY = "ma_artists_shared";

export const DEFAULT_ARTISTS: ArtistEntry[] = defaultArtists;
